import { render, staticRenderFns } from "./bulkshipment.vue?vue&type=template&id=49f67ffa"
import script from "./bulkshipment.vue?vue&type=script&lang=js"
export * from "./bulkshipment.vue?vue&type=script&lang=js"
import style0 from "./bulkshipment.vue?vue&type=style&index=0&id=49f67ffa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports